import { useEffect, useState } from "react";
import api from "../lib/api";
import GemstoneCard from "../components/GemstoneCard";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { toast } from "sonner";

const VIP = () => {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);
  const [appt, setAppt] = useState({ name: user?.name || "", email: user?.email || "", phone: "", message: "", preferred_date: "" });

  useEffect(() => {
    if (user && (user.role === "vip" || user.role === "admin")) {
      api.get("/vip/inventory").then(({ data }) => setItems(data));
    }
  }, [user]);

  if (loading) return <div className="pt-40 text-center text-white/40">Loading…</div>;
  if (!user || user === false) {
    return (
      <div className="pt-40 max-w-md mx-auto px-6 text-center">
        <p className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5">VIP Salon</p>
        <h1 className="font-heading text-5xl mb-6">Members only.</h1>
        <p className="text-white/60 mb-8">Sign in with your VIP credentials to access private inventory and concierge services.</p>
        <Link to="/login" className="inline-block bg-gold text-black font-accent uppercase tracking-[0.28em] text-xs px-9 py-4 hover:bg-ivory">Sign In</Link>
      </div>
    );
  }
  if (user.role !== "vip" && user.role !== "admin") {
    return (
      <div className="pt-40 max-w-md mx-auto px-6 text-center">
        <h1 className="font-heading text-4xl mb-6">VIP Access Required</h1>
        <p className="text-white/60 mb-6">This salon is reserved for verified VIP clients. Please contact concierge for an invitation.</p>
        <Link to="/concierge" className="inline-block border border-gold text-gold font-accent uppercase tracking-[0.28em] text-xs px-9 py-4 hover:bg-gold hover:text-black">Request Access</Link>
      </div>
    );
  }

  const submitAppt = async (e) => {
    e.preventDefault();
    try {
      await api.post("/inquiries", { type: "appointment", ...appt });
      toast.success("Private viewing requested.");
      setAppt({ ...appt, message: "", preferred_date: "" });
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };

  return (
    <div data-testid="vip-page" className="pt-32">
      <Seo title="VIP Salon" description="Private members salon for OPIKJEWELS." path="/vip" noIndex />
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-12">
        <p className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5">VIP Salon · {user.vip_tier || "Platinum"}</p>
        <h1 className="font-heading font-light text-5xl md:text-7xl">Welcome, {user.name}.</h1>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-20">
        <h2 className="font-heading text-3xl mb-8">Hidden Inventory</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((g) => <GemstoneCard key={g.id} gem={g} />)}
        </div>
        {items.length === 0 && <div className="text-white/40">No private inventory at this time.</div>}
      </section>

      <section className="bg-onyx border-t border-white/10 py-20">
        <div className="max-w-3xl mx-auto px-6">
          <p className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold mb-5">Private Viewing</p>
          <h2 className="font-heading text-4xl mb-8">Book an appointment.</h2>
          <form onSubmit={submitAppt} className="space-y-5">
            <input data-testid="appt-name" required placeholder="Name" value={appt.name} onChange={(e) => setAppt({...appt, name: e.target.value})} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
            <input data-testid="appt-email" required type="email" placeholder="Email" value={appt.email} onChange={(e) => setAppt({...appt, email: e.target.value})} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
            <input data-testid="appt-date" required type="date" value={appt.preferred_date} onChange={(e) => setAppt({...appt, preferred_date: e.target.value})} className="bg-transparent border-b border-white/20 px-0 py-3 w-full focus:outline-none focus:border-gold" />
            <textarea data-testid="appt-msg" required placeholder="Stones of interest, location preference…" rows={4} value={appt.message} onChange={(e) => setAppt({...appt, message: e.target.value})} className="bg-transparent border border-white/20 px-3 py-3 w-full focus:outline-none focus:border-gold" />
            <button data-testid="appt-submit" className="bg-gold text-black font-accent uppercase tracking-[0.28em] text-xs px-9 py-4 hover:bg-ivory">Request Viewing</button>
          </form>
        </div>
      </section>
      <div className="h-32"></div>
    </div>
  );
};

export default VIP;
